export function getLocaleResource(languageCode, resourceKey) {
    const LANGUAGE_CODE = "ba";
    return locales[LANGUAGE_CODE]?.[resourceKey] || "";
}

const locales = {
    mk: {
        yes: "Да",
        no: "Не",
        user: "Корисник",
        password: "Лозинка",
        login: "Најава",
        logout: "Одјава",
        brands: "Брендови",
        pricelist: "Ценовник",
        orders: "Нарачки",
        order: "Нарачка",
        invoices: "Фактури",
        invoice: "Фактура",
        cart: "Кошничка",
        carts: "Кошнички",
        dueAmount: "Долг",
        dueDays: "Денови",
        dueDate: "Валута",
        category: "Категорија",
        sku: "Шифра",
        product: "Производ",
        vat: "ДДВ",
        withVat: "со ДДВ",
        withoutVat: "без ДДВ",
        discount: "Попуст",
        price: "Цена",
        finalPrice: "Baша цена",
        stock: "Залиха",
        packaging: "Пакување",
        barcode: "Баркод",
        total: "Вкупно",
        address: "Адреса",
        person: "Лице",
        phone: "Телефон",
        note: "Коментар",
        date: "Датум",
        amount: "Износ",
        status: "Статус",
        users: "Корисници",
        products: "Производи",
        search: "Пребарување",
        placeOrder: "Испрати нарачка",
        addToCartSuccessful: "Успешно зачувана количина",
        finance: "Финансии",
        document: "Документ",
        debit: "Должи",
        credit: "Побарува",
        balance: "Салдо",
        client: "Клиент",
        company: "Компанија",
        quantity: "Количина",
        buyer: "Купувач",
        onSale: "Акција",
        newProducts: "Новитети",
        from: "Од",
        to: "До",
        revenue: "Промет",
        revenueMonthly: "Месечен промет",
        import: "Увоз",
        email: "Меил",
        last: "Последно",
        add: "Додади",
        delete: "Избриши",
        change: "Промени",
        companyKey: "Шифра",
        areYouSure: "Дали сте сигурни?",
        arrival: "Пристига",
        reservations: "Резервации",
        reservation: "Резервација",
        reserve: "Резервирај",
        reservationSuccessful: "Успешна резервација",
        emptyTheContent: "Испразни",
        minimumQuantityIs: "Минимална количина е",
        fitting: "Fitting",
    },
    ba: {
        yes: "Da",
        no: "Ne",
        user: "Korisnik",
        password: "Lozinka",
        login: "Prijava",
        logout: "Odjava",
        brands: "Brendove",
        pricelist: "Cjenovnik",
        orders: "Narudžbe",
        order: "Narudžba",
        invoices: "Fakture",
        invoice: "Faktura",
        cart: "Korpa",
        carts: "Korpe",
        dueAmount: "Dug van valute",
        dueDays: "Dani kašnjenja",
        dueDate: "Valuta",
        category: "Kategorija",
        sku: "Šifra",
        product: "Artikal",
        vat: "PDV",
        withVat: "sa PDV",
        withoutVat: "bez PDV",
        discount: "Rabat",
        price: "VPC",
        finalPrice: "Vaša cijena",
        stock: "Trenutna zaliha",
        packaging: "Pakovanje",
        barcode: "Barkod",
        total: "Ukupno",
        address: "Adresa",
        person: "Odgovorna osoba",
        phone: "Telefon",
        note: "Komentar",
        date: "Datum",
        amount: "Iznos",
        status: "Status",
        users: "Korisnike",
        products: "Proizvodi",
        search: "Pretraživanje",
        placeOrder: "Pošalji narudžbu",
        addToCartSuccessful: "Uspješno sačuvana količina",
        finance: "Finansije",
        document: "Dokument",
        debit: "Duguje",
        credit: "Potrazuje",
        balance: "Saldo",
        client: "Klijent",
        company: "Kompanija",
        quantity: "Količina",
        buyer: "Kupac",
        onSale: "Akcija",
        newProducts: "Novo",
        from: "Od",
        to: "Do",
        revenue: "Promet",
        revenueMonthly: "Mjesecni promet",
        import: "Import",
        email: "Mejl",
        last: "Zadnja",
        add: "Dodaj",
        delete: "Briši",
        change: "Promjeni",
        companyKey: "Šifra",
        areYouSure: "Jeste li sigurni?",
        arrival: "Ponovni dolazak robe",
        reservations: "Rezervacije",
        reservation: "Rezervacija",
        reserve: "Rezerviši",
        reservationSuccessful: "Uspješna rezervacija",
        emptyTheContent: "Ispraznite",
        minimumQuantityIs: "Minimalna količina je",
        fitting: "Fitting",
    },
};
